import React, { useContext, useState, useRef, useEffect } from "react";
import data from "../language.json";
import languageContext from "../context/language/languageContext";
import Question from "./Question";
import Answer from "./Answer";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Ask = ({ bookappointment, setbookappointment }) => {
  const {
    setSessionTimeout,
    dataApi,
    setData,
    setAlert,
    setMessage,
    isRightPanel,
    setIsRightPanel,
  } = useContext(languageContext);
  const [visible, setVisible] = useState(true);
  const [interactions, setInteractions] = useState([]); // Store questions and answers
  const [session, setsession] = useState({});
  const [input, setInput] = useState("");
  const mainBoxRef = useRef(null);
  const navigate = useNavigate();
  const lang =localStorage.getItem("lang")
 

  // Fetch API Response
  const gettingResponse = async (text) => {
    let headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };

    let bodyContent = JSON.stringify({
      question: text,
      session: session,
      lang: data[lang]["name"],
    });

    try {
      let response = await axios.post(
        "https://www.careplus.gopillz.com/nurse_al_voice_chat_webside",
        bodyContent,
        { headers: headersList }
      );
      if (response.data.ans !== "") {
        setInteractions((prev) => [
          ...prev,
          { type: "answer", text: response.data.ans, audio: null },
        ]);
        setData((prevData) => [
          ...prevData,
          { type: "answer", text: response.data.ans },
        ]);
        setsession(response.data.session);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data.detail === "Token has expired"
      ) {
        setSessionTimeout(true);
      } else {
        console.error("Error Details:", error.message);
        setAlert(true);
        setMessage("Please try again later, something went wrong");
      }
    }
  };

  // Ask Question and Handle Input
  const askQuestion = (text) => {
    if (text !== "") {
      setData((prevData) => [...prevData, { type: "question", text: text }]);
      setInteractions((prev) => [
        ...prev,
        { type: "question", text: text, audio: null },
      ]);
      gettingResponse(text);
      setInput("");
    }
  };

  // Handle Input Change
  const handleText = (e) => {
    setInput(e.target.value);
  };

  // Handle Enter Key to Send Message
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      askQuestion(input);
    }
  };

  // Scroll to Bottom After Interaction
  useEffect(() => {
    if (mainBoxRef.current) {
      mainBoxRef.current.scrollTop = mainBoxRef.current.scrollHeight;
    }
  }, [interactions]);

  return (
    <>
      <div className="flex flex-col lg:flex-row h-screen w-full bg-gray-100">
        {/* Main Chat Section */}
        <div className="flex flex-col w-full lg:w-8/12 mx-auto p-4 bg-white shadow-lg rounded-lg h-[90vh] relative">
          {/* Chat Box */}
          <div
            className="flex-grow overflow-y-auto px-4 py-2 space-y-4 pb-20" // Added padding-bottom to prevent overlap
            ref={mainBoxRef}
          >
            {interactions.map((interaction, index) =>
              interaction.type === "question" ? (
                <div key={index} className="mb-4">
                  <Question text={interaction.text} />
                </div>
              ) : (
                <Answer key={index} text={interaction.text} />
              )
            )}
              {visible && (
                 <div className="mx-2 mt-10 p-4 bg-gray-200 rounded-lg shadow-md text-gray-800 text-center font-semibold">
                  {console.log(lang)}
                 {data[localStorage.getItem("lang")]["Instructions"]}
               </div>
                )}

          </div>

          {/* Input Section */}
          <div className="bg-gray-100 absolute bottom-0 left-0 right-0 px-4 py-3 flex justify-between items-center space-x-2 rounded-b-lg shadow-inner">
            <input
              placeholder="Ask your question..."
              className="flex-1 px-4 py-2 rounded-md focus:outline-none border border-gray-300 w-full sm:w-auto"
              onChange={handleText}
              onKeyDown={handleKeyDown}
              value={input}
            />
            <button
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              onClick={() => askQuestion(input)}
            >
              Send
            </button>
          </div>
        </div>

        {/* Symptom Tracker Sidebar */}
        <div className="w-full lg:w-4/12 px-4 py-4 bg-gray-50 shadow-inner border-t lg:border-l border-gray-200 overflow-y-auto h-[90vh] rounded-lg">
          <h3 className="text-xl font-semibold text-gray-700 mb-4 text-center">
            Symptom Tracker
          </h3>

          <div className="grid grid-cols-2 gap-4">
            {data[lang]["Symptoms"].map((text, index) => (
              <button
                key={index}
                className="flex items-center justify-center space-x-2 bg-white border border-gray-300 shadow-sm hover:shadow-md hover:bg-blue-50 text-gray-700 font-medium px-4 py-3 rounded-lg transition duration-200 ease-in-out"
                onClick={() => askQuestion(text)}
              >
                <span className="text-sm">{text}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Ask;
